// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FSBT","colMin":"styles_colMin__19XaJ"};